
export default {
  getVessels: state => {
    return state.list.valueSeq().toArray();
  },
  getVesselsByIds: state => {
    return state.list.keys();
  },
  getVesselsSize: state => {
    return state.list.valueSeq().toArray().length;
  }
}
